// extracted by mini-css-extract-plugin
module.exports = {"desktop":"style_desktop__cQlZ_","mobile":"style_mobile__0OV_s"};